
import { defineComponent } from "vue";
import SortingArrow from "@/components/general/sortingArrow.vue";
import { mapGetters } from "vuex";

export default defineComponent({
  name: "countriesDataTable",
  data() {
    return {
      sortParams: {
        sortedBy: "",
        isOrderAsc: false
      }
    };
  },
  components: {
    SortingArrow
  },
  props: {
    tableData: Object
  },
  methods: {
    changeSort(userSelectedSortValue) {
      if (userSelectedSortValue == this.sortParams.sortedBy) {
        this.sortParams.isOrderAsc = !this.sortParams.isOrderAsc;
      } else {
        this.sortParams.isOrderAsc = false;
      }
      this.sortParams.sortedBy = userSelectedSortValue;
      this.$emit("changeSort", this.sortParams);
    },
    editButtonClicked(country) {
      this.$emit("editButtonClicked", country);
    },
    deleteButtonClicked(country) {
      this.$emit("deleteButtonClick", country);
    }
  },
  computed: {
    ...mapGetters("CountriesModule", ["getSortData"])
  },
  mounted() {
    this.sortParams = this.getSortData;
  }
});
